// Long-form page translations (Expertise, Modeles, Pourquoi)
export const pageTranslations = {
  fr: {
    expertisePage: {
      kicker: "Nos expertises",
      title1: "Quatre disciplines.",
      title2: "Une exigence absolue.",
      desc: "Notre collectif est concentré sur les domaines à plus haute valeur ajoutée. Chaque expertise est portée par une communauté interne, animée par des experts seniors et nourrie par notre R&D.",
      cyber: {
        tagline: "Protéger ce qui compte.",
        desc: "Nous accompagnons les RSSI sur l'ensemble de la chaîne de défense : gouvernance, audit, SOC, réponse à incident, conformité réglementaire.",
        items: [
          "Audit & analyse de risques (EBIOS RM, ISO 27005)",
          "Mise en place et opération de SOC / MSSP",
          "Conformité NIS2, DORA, ISO 27001, RGPD",
          "Réponse à incident & forensic",
          "Sécurité Cloud, Zero Trust, IAM",
        ],
      },
      bigdata: {
        tagline: "Exploiter la donnée à l'échelle.",
        desc: "Des architectures data robustes pensées pour la production : ingestion temps réel, gouvernance et industrialisation des cas d'usage.",
        items: [
          "Architectures Data Lake / Lakehouse",
          "Streaming temps réel (Kafka, Flink, Spark)",
          "Data Governance, qualité et catalogue",
          "DataOps, plateformes self-service",
          "Migration on-prem vers Cloud (AWS, GCP, Azure)",
        ],
      },
      ai: {
        tagline: "De la promesse au déploiement.",
        desc: "Nous transformons les expérimentations IA en produits robustes : LLMs, RAG, vision, recherche sémantique, et automatisation.",
        items: [
          "Génération augmentée (RAG), agents et assistants",
          "Fine-tuning et alignement de LLMs",
          "Vision par ordinateur & OCR avancé",
          "MLOps, observabilité et monitoring de modèles",
          "Cadrage éthique et IA responsable",
        ],
      },
      pm: {
        tagline: "L'exécution est notre obsession.",
        desc: "PMO, direction de programme et accompagnement agile pour livrer des projets critiques dans les délais et le budget.",
        items: [
          "Direction de programme & PMO transverse",
          "Méthodes agiles à l'échelle (SAFe, Spotify)",
          "Pilotage de projets régaliens et complexes",
          "Conduite du changement et adoption",
          "Audit de projet et redressement",
        ],
      },
      ctaTitle: "Un projet qui croise plusieurs expertises ?",
      ctaDesc: "Nos équipes sont conçues pour orchestrer la collaboration.",
      ctaButton: "Parler à un expert",
    },
    modelesPage: {
      kicker: "Modèles de livraison",
      title1: "Trois façons.",
      title2: "Un seul niveau d'exigence.",
      desc: "Selon la nature de votre besoin et votre tolérance au risque, nous adaptons la formule contractuelle et le modèle d'engagement.",
      fitLabel: "Adapté à : ",
      m1: {
        title: "Assistance Technique",
        pitch: "Renforcez vos équipes avec des consultants experts intégrés.",
        desc: "Vous gardez la main sur le pilotage et le périmètre. Nous mettons à disposition les compétences seniors nécessaires, rapidement et avec engagement de remplacement.",
        bullets: [
          "Time-to-staff inférieur à 5 jours",
          "Profils seniors validés par nos communautés d'expertise",
          "Suivi qualité hebdomadaire et engagement de remplacement",
          "Modèle facturation TJM ou forfait jour",
        ],
        fit: "Idéal pour combler un besoin précis ou renforcer une équipe existante.",
      },
      m2: {
        title: "Centres de Services",
        pitch: "Confiez-nous le pilotage d'une équipe dédiée, en run ou en build.",
        desc: "Hecnos prend en charge la constitution, le pilotage et la performance d'une équipe pluridisciplinaire avec des SLAs et engagements de service mesurables.",
        bullets: [
          "Engagement de moyens et de résultats (SLA)",
          "Pilotage agile, reporting transparent",
          "Équipes onshore, nearshore ou hybrides",
          "Outillage industrialisé et bonnes pratiques",
        ],
        fit: "Idéal pour des activités récurrentes ou des chantiers transverses de moyenne durée.",
      },
      m3: {
        title: "Projets au Forfait",
        pitch: "Un périmètre, un délai, un budget. Le risque est de notre côté.",
        desc: "Nous prenons l'engagement sur le résultat. Cadrage, conception, réalisation, recette : Hecnos s'engage sur l'ensemble du cycle de livraison.",
        bullets: [
          "Engagement ferme sur périmètre / délai / budget",
          "Méthodologie hybride agile + jalons fixes",
          "Garantie post-mise en production",
          "Co-construction du cahier des charges",
        ],
        fit: "Idéal lorsque le besoin est cadré et que vous souhaitez transférer le risque opérationnel.",
      },
      ctaTitle1: "Hésitez sur le bon modèle ?",
      ctaTitle2: "Discutons-en.",
      ctaButton: "Demander un cadrage",
    },
    pourquoiPage: {
      kicker: "Pourquoi Hecnos",
      title1: "Un collectif.",
      title2: "Pas une pyramide.",
      desc: "Hecnos a été fondé sur une conviction simple : seuls les collectifs d'experts engagés livrent des transformations qui durent.",
      p1: {
        title: "Une expertise collective, pas une pyramide",
        desc: "Nos consultants sont seniors et engagés. Pas de profils en formation déguisés en experts, pas de cabinet de revente. Chaque mission est cadrée par un référent technique reconnu dans sa discipline.",
      },
      p2: {
        title: "Une expérience collaborateur singulière",
        desc: "Mobilité interne, communautés d'expertise, mentoring, budget formation, R&D ouverte. Chez Hecnos, l'épanouissement professionnel est une obligation de moyens, pas un slogan.",
      },
      p3: {
        title: "Un état d'esprit d'innovation continue",
        desc: "Veille active, R&D interne, hackathons, prototypage rapide. L'innovation n'est pas un département : c'est une méthode de travail au quotidien, partagée par tout le collectif.",
      },
      ctaTitle: "Vous voulez en faire partie ?",
      ctaDesc: "Nous recrutons en continu sur nos quatre expertises. Postes en CDI, missions internationales, et un parcours de carrière à votre rythme.",
      ctaButton: "Rejoindre l'aventure",
    },
  },

  en: {
    expertisePage: {
      kicker: "Our expertise",
      title1: "Four disciplines.",
      title2: "Absolute excellence.",
      desc: "Our collective focuses on the highest-value-added domains. Each expertise is carried by an internal community, led by senior experts and fueled by our R&D.",
      cyber: {
        tagline: "Protect what matters.",
        desc: "We support CISOs across the entire defense chain: governance, audit, SOC, incident response, regulatory compliance.",
        items: [
          "Audit & risk analysis (EBIOS RM, ISO 27005)",
          "SOC / MSSP setup and operations",
          "NIS2, DORA, ISO 27001, GDPR compliance",
          "Incident response & forensics",
          "Cloud security, Zero Trust, IAM",
        ],
      },
      bigdata: {
        tagline: "Exploit data at scale.",
        desc: "Robust data architectures designed for production: real-time ingestion, governance and industrialised use cases.",
        items: [
          "Data Lake / Lakehouse architectures",
          "Real-time streaming (Kafka, Flink, Spark)",
          "Data governance, quality and catalog",
          "DataOps, self-service platforms",
          "On-prem to Cloud migration (AWS, GCP, Azure)",
        ],
      },
      ai: {
        tagline: "From promise to deployment.",
        desc: "We turn AI experiments into robust products: LLMs, RAG, vision, semantic search, and automation.",
        items: [
          "Retrieval-Augmented Generation (RAG), agents and assistants",
          "LLM fine-tuning and alignment",
          "Computer vision & advanced OCR",
          "MLOps, observability and model monitoring",
          "Ethics scoping and responsible AI",
        ],
      },
      pm: {
        tagline: "Execution is our obsession.",
        desc: "PMO, program management and agile support to deliver critical projects on time and on budget.",
        items: [
          "Program management & cross-cutting PMO",
          "Scaled agile methods (SAFe, Spotify)",
          "Steering of mission-critical and complex projects",
          "Change management and adoption",
          "Project audit and turnaround",
        ],
      },
      ctaTitle: "A project that crosses multiple expertises?",
      ctaDesc: "Our teams are designed to orchestrate collaboration.",
      ctaButton: "Talk to an expert",
    },
    modelesPage: {
      kicker: "Delivery models",
      title1: "Three ways.",
      title2: "One level of excellence.",
      desc: "Depending on the nature of your need and your risk appetite, we adapt the contractual formula and engagement model.",
      fitLabel: "Suited for: ",
      m1: {
        title: "Technical Assistance",
        pitch: "Reinforce your teams with embedded expert consultants.",
        desc: "You keep control of governance and scope. We provide the senior skills you need, fast, with a replacement guarantee.",
        bullets: [
          "Time-to-staff under 5 days",
          "Senior profiles validated by our expert communities",
          "Weekly quality follow-up and replacement guarantee",
          "Daily rate or day-package billing",
        ],
        fit: "Ideal to fill a precise need or strengthen an existing team.",
      },
      m2: {
        title: "Service Centers",
        pitch: "Entrust us with the steering of a dedicated team, in run or build mode.",
        desc: "Hecnos handles the constitution, steering and performance of a multidisciplinary team with measurable SLAs and service commitments.",
        bullets: [
          "Means and results commitment (SLA)",
          "Agile steering, transparent reporting",
          "Onshore, nearshore or hybrid teams",
          "Industrialised tooling and best practices",
        ],
        fit: "Ideal for recurring activities or mid-term cross-cutting workstreams.",
      },
      m3: {
        title: "Fixed-price Projects",
        pitch: "One scope, one timeline, one budget. The risk is on our side.",
        desc: "We commit on the outcome. Framing, design, build, acceptance: Hecnos commits to the full delivery cycle.",
        bullets: [
          "Firm commitment on scope / timeline / budget",
          "Hybrid methodology: agile + fixed milestones",
          "Post-go-live warranty",
          "Co-construction of the specification",
        ],
        fit: "Ideal when the need is well scoped and you want to transfer operational risk.",
      },
      ctaTitle1: "Unsure about the right model?",
      ctaTitle2: "Let's discuss it.",
      ctaButton: "Request a scoping",
    },
    pourquoiPage: {
      kicker: "Why Hecnos",
      title1: "A collective.",
      title2: "Not a pyramid.",
      desc: "Hecnos was founded on a simple belief: only collectives of committed experts deliver transformations that last.",
      p1: {
        title: "Collective expertise, not a pyramid",
        desc: "Our consultants are senior and committed. No trainees disguised as experts, no resale shop. Every mission is framed by a technical lead recognised in their discipline.",
      },
      p2: {
        title: "A singular employee experience",
        desc: "Internal mobility, expertise communities, mentoring, training budget, open R&D. At Hecnos, professional growth is an obligation of means, not a slogan.",
      },
      p3: {
        title: "A continuous innovation mindset",
        desc: "Active scouting, internal R&D, hackathons, rapid prototyping. Innovation is not a department: it is a daily working method, shared by the entire collective.",
      },
      ctaTitle: "Want to be part of it?",
      ctaDesc: "We hire continuously across our four expertises. Permanent positions, international missions, and a career path at your own pace.",
      ctaButton: "Join the adventure",
    },
  },

  es: {
    expertisePage: {
      kicker: "Nuestra experiencia",
      title1: "Cuatro disciplinas.",
      title2: "Una exigencia absoluta.",
      desc: "Nuestro colectivo se concentra en los dominios de mayor valor añadido. Cada experiencia la lleva una comunidad interna, animada por expertos seniors y alimentada por nuestra I+D.",
      cyber: {
        tagline: "Proteger lo que importa.",
        desc: "Acompañamos a los CISO en toda la cadena de defensa: gobernanza, auditoría, SOC, respuesta a incidentes, cumplimiento normativo.",
        items: [
          "Auditoría y análisis de riesgos (EBIOS RM, ISO 27005)",
          "Despliegue y operación de SOC / MSSP",
          "Cumplimiento NIS2, DORA, ISO 27001, RGPD",
          "Respuesta a incidentes y forense",
          "Seguridad Cloud, Zero Trust, IAM",
        ],
      },
      bigdata: {
        tagline: "Explotar los datos a escala.",
        desc: "Arquitecturas de datos robustas pensadas para producción: ingestión en tiempo real, gobernanza e industrialización de casos de uso.",
        items: [
          "Arquitecturas Data Lake / Lakehouse",
          "Streaming en tiempo real (Kafka, Flink, Spark)",
          "Gobernanza, calidad y catálogo de datos",
          "DataOps, plataformas self-service",
          "Migración on-prem a Cloud (AWS, GCP, Azure)",
        ],
      },
      ai: {
        tagline: "De la promesa al despliegue.",
        desc: "Convertimos los experimentos de IA en productos robustos: LLMs, RAG, visión, búsqueda semántica y automatización.",
        items: [
          "Generación aumentada (RAG), agentes y asistentes",
          "Fine-tuning y alineamiento de LLMs",
          "Visión por computadora y OCR avanzado",
          "MLOps, observabilidad y monitorización de modelos",
          "Marco ético e IA responsable",
        ],
      },
      pm: {
        tagline: "La ejecución es nuestra obsesión.",
        desc: "PMO, dirección de programa y acompañamiento ágil para entregar proyectos críticos en plazo y presupuesto.",
        items: [
          "Dirección de programa y PMO transversal",
          "Métodos ágiles a escala (SAFe, Spotify)",
          "Pilotaje de proyectos críticos y complejos",
          "Gestión del cambio y adopción",
          "Auditoría y recuperación de proyectos",
        ],
      },
      ctaTitle: "¿Un proyecto que cruza varias experiencias?",
      ctaDesc: "Nuestros equipos están diseñados para orquestar la colaboración.",
      ctaButton: "Hablar con un experto",
    },
    modelesPage: {
      kicker: "Modelos de entrega",
      title1: "Tres maneras.",
      title2: "Un solo nivel de exigencia.",
      desc: "Según la naturaleza de su necesidad y su tolerancia al riesgo, adaptamos la fórmula contractual y el modelo de compromiso.",
      fitLabel: "Ideal para: ",
      m1: {
        title: "Asistencia Técnica",
        pitch: "Refuerce sus equipos con consultores expertos integrados.",
        desc: "Usted mantiene el pilotaje y el alcance. Aportamos las competencias senior necesarias, rápidamente y con garantía de reemplazo.",
        bullets: [
          "Time-to-staff inferior a 5 días",
          "Perfiles senior validados por nuestras comunidades",
          "Seguimiento de calidad semanal y garantía de reemplazo",
          "Facturación por TJM o paquete diario",
        ],
        fit: "Ideal para cubrir una necesidad precisa o reforzar un equipo existente.",
      },
      m2: {
        title: "Centros de Servicios",
        pitch: "Confíenos el pilotaje de un equipo dedicado, en run o en build.",
        desc: "Hecnos asume la constitución, el pilotaje y el rendimiento de un equipo multidisciplinario con SLAs y compromisos medibles.",
        bullets: [
          "Compromiso de medios y resultados (SLA)",
          "Pilotaje ágil, reporting transparente",
          "Equipos onshore, nearshore o híbridos",
          "Herramientas industrializadas y buenas prácticas",
        ],
        fit: "Ideal para actividades recurrentes o iniciativas transversales de duración media.",
      },
      m3: {
        title: "Proyectos a Precio Fijo",
        pitch: "Un alcance, un plazo, un presupuesto. El riesgo está de nuestro lado.",
        desc: "Nos comprometemos con el resultado. Marco, diseño, ejecución, aceptación: Hecnos se compromete con todo el ciclo de entrega.",
        bullets: [
          "Compromiso firme sobre alcance / plazo / presupuesto",
          "Metodología híbrida: ágil + hitos fijos",
          "Garantía post-puesta en producción",
          "Co-construcción del pliego",
        ],
        fit: "Ideal cuando la necesidad está acotada y quiere transferir el riesgo operacional.",
      },
      ctaTitle1: "¿Duda sobre el modelo adecuado?",
      ctaTitle2: "Hablemos.",
      ctaButton: "Solicitar un encuadre",
    },
    pourquoiPage: {
      kicker: "Por qué Hecnos",
      title1: "Un colectivo.",
      title2: "No una pirámide.",
      desc: "Hecnos fue fundada sobre una convicción simple: solo los colectivos de expertos comprometidos entregan transformaciones duraderas.",
      p1: {
        title: "Una experiencia colectiva, no una pirámide",
        desc: "Nuestros consultores son senior y comprometidos. Sin perfiles en formación disfrazados de expertos, sin reventa. Cada misión está enmarcada por un referente técnico reconocido.",
      },
      p2: {
        title: "Una experiencia de colaborador singular",
        desc: "Movilidad interna, comunidades de experiencia, mentoría, presupuesto de formación, I+D abierta. En Hecnos, el desarrollo profesional es una obligación de medios, no un eslogan.",
      },
      p3: {
        title: "Una mentalidad de innovación continua",
        desc: "Vigilancia activa, I+D interna, hackathons, prototipado rápido. La innovación no es un departamento: es un método diario, compartido por todo el colectivo.",
      },
      ctaTitle: "¿Quiere formar parte?",
      ctaDesc: "Contratamos continuamente en nuestras cuatro experiencias. Puestos indefinidos, misiones internacionales y una carrera a su ritmo.",
      ctaButton: "Únase a la aventura",
    },
  },

  zh: {
    expertisePage: {
      kicker: "我们的专业领域",
      title1: "四大学科。",
      title2: "绝对的卓越标准。",
      desc: "我们的集体专注于价值最高的领域。每个专业领域都由内部社区承载,由资深专家带领,并由我们的研发支持。",
      cyber: {
        tagline: "守护重要资产。",
        desc: "我们陪伴 CISO 走完整条防御链:治理、审计、SOC、事件响应、合规。",
        items: [
          "审计与风险分析 (EBIOS RM、ISO 27005)",
          "SOC / MSSP 建设与运营",
          "NIS2、DORA、ISO 27001、GDPR 合规",
          "事件响应与取证",
          "云安全、零信任、IAM",
        ],
      },
      bigdata: {
        tagline: "规模化挖掘数据价值。",
        desc: "为生产环境量身设计的稳健数据架构:实时摄取、治理和用例工业化。",
        items: [
          "Data Lake / Lakehouse 架构",
          "实时流式处理 (Kafka、Flink、Spark)",
          "数据治理、质量与目录",
          "DataOps,自助式平台",
          "On-prem 迁移至云 (AWS、GCP、Azure)",
        ],
      },
      ai: {
        tagline: "从承诺到落地。",
        desc: "我们把 AI 实验变为稳健的产品:LLM、RAG、视觉、语义搜索与自动化。",
        items: [
          "检索增强生成 (RAG)、智能体与助手",
          "LLM 微调与对齐",
          "计算机视觉与高级 OCR",
          "MLOps、模型可观测与监控",
          "伦理框架与负责任的 AI",
        ],
      },
      pm: {
        tagline: "执行是我们的执念。",
        desc: "PMO、项目集管理与敏捷支持,按时按预算交付关键项目。",
        items: [
          "项目集管理与跨领域 PMO",
          "规模化敏捷 (SAFe、Spotify)",
          "关键与复杂项目的引领",
          "变革管理与采用",
          "项目审计与挽救",
        ],
      },
      ctaTitle: "需要跨多个专业的项目?",
      ctaDesc: "我们的团队就是为协作编排而设计。",
      ctaButton: "与专家交流",
    },
    modelesPage: {
      kicker: "交付模式",
      title1: "三种方式。",
      title2: "同一卓越标准。",
      desc: "根据您的需求性质和风险偏好,我们调整合同形式与合作模式。",
      fitLabel: "适用于: ",
      m1: {
        title: "技术支援",
        pitch: "派驻专家顾问加强您的团队。",
        desc: "您主导治理与范围。我们快速提供所需的高级技能,并承诺替换。",
        bullets: [
          "5 天以内到位",
          "由专家社区审核的资深人才",
          "每周质量跟进与替换承诺",
          "按日费率或日包月计费",
        ],
        fit: "适合补齐精准需求或加强既有团队。",
      },
      m2: {
        title: "服务中心",
        pitch: "把专属团队的运行或建设交给我们。",
        desc: "Hecnos 负责组建、引领并保证一支多学科团队的绩效,带可衡量的 SLA。",
        bullets: [
          "手段与结果承诺 (SLA)",
          "敏捷引领,透明报告",
          "本地、近岸或混合团队",
          "工业化工具与最佳实践",
        ],
        fit: "适合循环性活动或中长期跨域项目。",
      },
      m3: {
        title: "整包项目",
        pitch: "一个范围、一个工期、一个预算。风险由我们承担。",
        desc: "我们对结果负责。框架、设计、开发、验收 —— Hecnos 承诺完整交付周期。",
        bullets: [
          "对范围 / 工期 / 预算的硬承诺",
          "敏捷 + 固定里程碑的混合方法",
          "上线后保修",
          "共同构建需求规格",
        ],
        fit: "适合需求已明确、希望转移运营风险的场景。",
      },
      ctaTitle1: "不确定该选哪种模式?",
      ctaTitle2: "我们聊聊。",
      ctaButton: "申请方案咨询",
    },
    pourquoiPage: {
      kicker: "为何选择 Hecnos",
      title1: "一个集体。",
      title2: "不是金字塔。",
      desc: "Hecnos 创立于一个简单的信念:只有由专家组成的承担集体,才能交付可持续的转型。",
      p1: {
        title: "集体专业,不是金字塔",
        desc: "我们的顾问资深且投入。没有伪装成专家的实习生,也没有人力转售。每个项目都有领域里被认可的技术负责人。",
      },
      p2: {
        title: "独特的员工体验",
        desc: "内部流动、专业社区、导师机制、培训预算、开放研发。在 Hecnos,职业成长是手段义务,不是口号。",
      },
      p3: {
        title: "持续创新的心态",
        desc: "主动情报、内部研发、黑客松、快速原型。创新不是一个部门,而是全集体共享的日常方法。",
      },
      ctaTitle: "想成为其中一员?",
      ctaDesc: "我们在四大专业领域持续招聘。长期合同、国际项目,按自己的节奏成长。",
      ctaButton: "加入我们",
    },
  },
};
